<template>
  <!-- 柱图组件 -->
  <div class="chart-container" :id="id"></div>
</template>
<script>
export default {
  props: {
    id: {
      type: String
    },
    option: {
      type: Object
    }
  },
  data() {
    return {
      chartGraph: null
    };
  },
  computed: {
    abc: function() {
      return this.option.wat;
    }
  },
  watch: {
    // abc:{
    //     handle(newValue,oldValue){
    //         alert('123');
    //     //    this.drawGraph(this.id,newValue);
    //     }
    // }

    abc(newValue, oldValue) {
      this.drawGraph(this.id, this.option);
    }
  },
  methods: {
    drawGraph(id, option) {
      let _self = this;
      _self.chartGraph = echarts.init(document.getElementById(id));
      _self.chartGraph.setOption(option, true);

      window.addEventListener("resize", function() {
        _self.chartGraph.resize();
      });
    }
  },
  mounted() {
    this.drawGraph(this.id, this.option);
  },
  beforeDestroy() {
    if (this.chartGraph) {
      this.chartGraph.clear();
    }
  }
};
</script>
<style lang="less">
</style>


